module.exports = __webpack_public_path__ + "src/images/products/sneakerhead/69_Cut-Off Sweatshort.png";